define(
    [
        'jquery',
        'underscore',
        'assets/js/modules/product/model/attributeModel',
        'assets/js/modules/option/optionValueModel',
        'assets/js/modules/design/designModel',
        'assets/js/modules/design/designFaceModel',
        'assets/js/modules/design/designFaceProcessModel',
        'assets/js/modules/designPreview/changeOptionsEventHandler',
        'assets/js/modules/designPreview/samples/samples'
    ],
    function(
        $,
        _,
        AttributeModel,
        OptionValueModel,
        DesignModel,
        DesignFaceModel,
        DesignFaceProcessModel,
        ChangeOptionsEventHandler,
        samples
    ) {
        return {
            createDesignModel: function(productParams, designParams) {
                const _this = this;

                let defaultDesignParams = {
                    pgId: null,
                    designerType: null,
                    frontId: undefined,
                    frontPath: undefined,
                    backId: undefined,
                    backPath: undefined,
                    frontSpotUVPath: undefined,
                    backSpotUVPath: undefined,
                    frontTexturePath: undefined,
                    backTexturePath: undefined,
                    frontFoilPath: undefined,
                    backFoilPath: undefined,
                    selectedOptions: {}
                };

                designParams = $.extend(defaultDesignParams, designParams);

                let defaultOptions = this.getDefaultOptions(productParams.defaultOptions);

                let frontProcesses = [];
                let backProcesses = [];

                frontProcesses.push({
                    src: designParams.frontPath,
                    type: DesignFaceProcessModel.TYPE_REGULAR,
                    fileId: designParams.frontId,
                    sessionId: designParams.sessionId
                });
                if (designParams.frontSpotUVPath !== undefined && designParams.frontSpotUVPath.length > 0) {
                    frontProcesses.push({
                        src: designParams.frontSpotUVPath,
                        type: DesignFaceProcessModel.TYPE_SPOT_UV
                    });
                } else if (designParams.frontTexturePath !== undefined && designParams.frontTexturePath.length > 0) {
                    frontProcesses.push({
                        src: designParams.frontTexturePath,
                        type: DesignFaceProcessModel.TYPE_TEXTURE
                    });
                } else if (designParams.frontFoilPath !== undefined && designParams.frontFoilPath.length > 0) {
                    frontProcesses.push({
                        src: designParams.frontFoilPath,
                        type: DesignFaceProcessModel.TYPE_FOIL
                    });
                }

                backProcesses.push({
                    src: designParams.backPath,
                    type: DesignFaceProcessModel.TYPE_REGULAR,
                    fileId: designParams.backId
                });
                if (designParams.backSpotUVPath !== undefined && designParams.backSpotUVPath.length > 0) {
                    backProcesses.push({
                        src: designParams.backSpotUVPath,
                        type: DesignFaceProcessModel.TYPE_SPOT_UV
                    });
                } else if (designParams.backTexturePath !== undefined && designParams.backTexturePath.length > 0) {
                    backProcesses.push({
                        src: designParams.backTexturePath,
                        type: DesignFaceProcessModel.TYPE_TEXTURE
                    });
                } else if (designParams.backFoilPath !== undefined && designParams.backFoilPath.length > 0) {
                    backProcesses.push({
                        src: designParams.backFoilPath,
                        type: DesignFaceProcessModel.TYPE_FOIL
                    });
                }

                let designObj = {
                    pgId: designParams.pgId,

                    designerType: designParams.designerType,

                    productContext: {
                        slug: productParams.productType,
                        group: productParams.productGroup,
                        shape: productParams.productShape,
                        bleedRatio: productParams.bleedRatio,
                        defaultOptions: defaultOptions,
                        isCrossSells: DesignModel.isCrossSells(productParams.productType, productParams.availableSubstrates),
                        samples: productParams.productSamples
                    },

                    faces: [
                        {
                            type: DesignFaceModel.TYPE_FRONT,
                            processes: frontProcesses
                        },
                        {
                            type: DesignFaceModel.TYPE_BACK,
                            processes: backProcesses
                        }
                    ],

                    width: designParams.width,
                    height: designParams.height,

                    orientation: designParams.orientation,

                    optionsContext: designParams.selectedOptions,

                    isSample: designParams.useSampleDesign
                };

                let designModel = null;

                if (designParams.useSampleDesign) {
                    const hasBack = productParams.numOfSides == 2;
                    designObj = $.extend(
                        designObj,
                        this.getDesignPrototype(
                            productParams.productType,
                            productParams.bleedRatio,
                            productParams.productSamples,
                            hasBack,
                            designParams
                        )
                    );

                    designModel = new DesignModel(designObj);

                    designModel.on('changed', function() {
                        let productContext = this.get('productContext');
                        let obj = _.extend(
                            _this.getDesignPrototype(
                                productContext.get('slug'),
                                productContext.get('bleedRatio'),
                                productContext.get('samples'),
                                hasBack,
                                designParams,
                                this
                            ),
                            {
                                productContext: {
                                    defaultOptions: defaultOptions
                                }
                            }
                        );

                        designModel.set(obj, { remove: false, merge: true });
                    });

                    designModel.get('optionsContext').on('change:folding', function(model, folding) {
                        let productContext = designModel.get('productContext');
                        let obj = _this.getDesignPrototype(
                            productContext.get('slug'),
                            productContext.get('bleedRatio'),
                            productContext.get('samples'),
                            hasBack,
                            designParams,
                            designModel
                        );
                        designModel.set(obj, { remove: false, merge: true });
                    });
                } else {
                    designModel = new DesignModel(designObj);
                }

                return designModel;
            },

            /**
             * @param {string[]} optionValueNames
             * @returns {Object}
             */
            getDefaultOptions: function(optionValueNames) {
                let defaultOptions = {};
                if (optionValueNames) {
                    const defaultCornersOptions = _.intersection(optionValueNames, [
                        OptionValueModel.NAME_ROUNDED_CORNERS,
                        OptionValueModel.NAME_SQUARE_CORNERS
                    ]);
                    const defaultUploadPatternOptions = _.intersection(optionValueNames, [
                        OptionValueModel.NAME_UPLOAD_PATTERN_NONE,
                        OptionValueModel.NAME_UPLOAD_PATTERN_TILE
                    ]);
                    if (defaultCornersOptions.length) {
                        defaultOptions.rc = defaultCornersOptions[0];
                    }
                    if (defaultUploadPatternOptions.length) {
                        defaultOptions.uploadPattern = defaultUploadPatternOptions[0];
                    }
                }

                return defaultOptions;
            },

            getDesignPrototype: function(productType, bleedRatio, productSamples, hasBack, designParams, designModel) {
                let folding = designParams.selectedOptions.folding;
                let uploadPattern = designParams.selectedOptions.uploadPattern;
                let frontCoating = null;
                let backCoating = null;

                if (designModel) {
                    folding = designModel.get('optionsContext').get('folding');
                    uploadPattern = designModel.get('optionsContext').get('uploadPattern');
                    frontCoating = designModel.get('optionsContext').get('frontCoating');
                    backCoating = designModel.get('optionsContext').get('backCoating');
                }

                return samples.getDesignPreviewSample(
                    productType,
                    bleedRatio,
                    productSamples,
                    hasBack,
                    folding,
                    uploadPattern,
                    frontCoating,
                    backCoating
                );
            }
        };
    }
);
